export default __webpack_public_path__ + "assets/sounds/aead0f712bd4fd6ad527f2fcad8360cb.mp3";